import type { NextApiRequest, NextApiResponse } from 'next';
import { withAuth } from '../../../lib/apiAuth';
import { cegidERP } from '../../../lib/cegid';

/**
 * S2.7: Proxy endpoint for Cegid ERP companies.
 * GET /api/cegid/companies
 * Only admin and asesor can access.
 */
async function handler(
  req: NextApiRequest,
  res: NextApiResponse,
  user: { id: string; email: string; roles: string[]; primaryRole: string }
) {
  if (req.method !== 'GET') {
    return res.status(405).json({ error: 'Method not allowed' });
  }

  try {
    const companies = await cegidERP.getCompanies();
    return res.status(200).json({ success: true, data: companies });
  } catch (error: any) {
    console.error('[Cegid Companies] Error:', error.message);
    return res.status(500).json({ error: 'Error al obtener empresas de Cegid.', details: error.message });
  }
}

export default withAuth(handler, ['admin', 'asesor']);
